import React from 'react';

import { Label } from '../../components';

const Value = ({ className, attr, title, children }) => {
  return (
    <div className={`input ${className}`}>
      <Label attr={attr} text={title} />
      {children}
    </div>
  );
};

export default Value;
